<script setup lang="ts">
import Icon from '~/components/common/Icon.vue'
import tippy from 'tippy.js'

const props = withDefaults(
  defineProps<{
    label: string
    tooltip?: string
    tooltipOptions?: {
      maxWidth?: number
      arrow?: boolean
      placement?: 'top' | 'bottom' | 'left' | 'right'
    }
  }>(),
  {
    tooltipOptions: () => ({
      maxWidth: 408,
      arrow: true,
      placement: 'bottom',
    }),
  },
)

const tooltipRef = ref(null)
const hasTooltip = computed(
  () => props.tooltip !== undefined && props.tooltip !== '',
)

onMounted(() => {
  if (!hasTooltip.value) return

  nextTick(() => {
    tippy(tooltipRef.value, {
      content: `
        <div class="p-4 text-white text-sm rounded-lg" style="background: #23252c;">
            <div>
              ${props.tooltip}
            </div>
        </div>
        `,
      allowHTML: true,
      maxWidth: props.tooltipOptions.maxWidth,
      arrow: props.tooltipOptions.arrow,
      placement: props.tooltipOptions.placement,
    })
  })
})
</script>

<template>
  <div v-if="!hasTooltip" class="text-right leading-6">{{ label }}</div>
  <div
    v-else
    ref="tooltipRef"
    class="group flex cursor-pointer items-center justify-end gap-x-1 leading-[26px]"
  >
    <span>{{ label }}</span>
    <Icon name="exclamation-circle" class="group-hover:text-p-700" />
  </div>
</template>
